import React from "react";

export default function BazookaOverlay({ phase }) {
  if (!phase) return null;
  return (
    <>
      <img
        src="/hand.png"
        alt=""
        className={`bazooka-hand ${phase === "rise" ? "bazooka-rising" : phase === "lower" ? "bazooka-lowering" : "bazooka-risen"}`}
        draggable={false}
      />
      {(phase === "fire" || phase === "explode") && (
        <div className="explosion-sprite" />
      )}
    </>
  );
}
